const AGENT_PROMPT_CONTENT_TYPE = 'application/vnd.iris.aiplatform.agent-prompt+json';
export class AgentPromptService {
    static $inject = ['AiApplicationService', 'ContextProcessorService'];
    constructor(AiApplicationService, ContextProcessorService) {
        this.AiApplicationService = AiApplicationService;
        this.ContextProcessorService = ContextProcessorService;
    }
    async sendPromptCommand(stateId, path, type, resource) {
        const tenantId = this.getTenantId();
        const uri = `/autopilots/${tenantId}/prompt/${stateId}/${path}`;
        return this.AiApplicationService.processCommandOrThrow({
            method: 'set',
            type,
            uri,
            resource,
        });
    }
    async generateInstructions(context, stateId) {
        return this.sendPromptCommand(stateId, 'generate', AGENT_PROMPT_CONTENT_TYPE, { task: context });
    }
    async optimizeInstructions(currentInstructions, stateId) {
        return this.sendPromptCommand(stateId, 'optimize', AGENT_PROMPT_CONTENT_TYPE, { prompt: currentInstructions });
    }
    //#region Private Methods
    getTenantId() {
        return this.ContextProcessorService.tenant.id;
    }
}
AgentPromptService.$inject = ['AiApplicationService', 'ContextProcessorService'];
